import { useNavigate, useParams } from "react-router-dom";
import Profile from "../../pages/profile/pg-profile";
import Footer from "../../components/footer-tab/fixedfooter";
import SignIn from "../../pages/profile/pg-profile-signin";
import OTP from "../../pages/profile/pg-profile-otp";
import REGISTER from "../../pages/profile/pg-profile-customer-register";
import ADDRESSLIST from "../../pages/profile/pg-profile-address-list";
import ADDNEWADDRESS from "../../pages/profile/pg-profile-add-new-address";
import HeaderCommon from "../../components/header-tab/fixed-common-header";
import GoogleMap from "../../components/google-map/google-map";
import COMPLETEDORDERS from "../../pages/profile/pg-profile-completed-orders";
import PRIVACYPOLICY from "../../pages/profile/pg-profile-privacy-policy";
import DAITONN from "../../pages/profile/pg-profile-daitonn";
import { ToastContainer } from "react-toastify";

export function RTProfile(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <Profile navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}
export function RTSignin(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <SignIn navigate={navigate} params={params} />
    </>
  );
}

export function RTOTP(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <OTP navigate={navigate} params={params} />
    </>
  );
}

export function RTREGISTER(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <REGISTER navigate={navigate} params={params} />
    </>
  );
}

export function RTADDRESSLIST(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <ADDRESSLIST navigate={navigate} params={params} />
    </>
  );
}

export function RTADDNEWADDRESS(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <ADDNEWADDRESS navigate={navigate} params={params} />
    </>
  );
}

export function RTMAP(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <GoogleMap navigate={navigate} params={params} />
    </>
  );
}

export function RTCOMPLETEORDER(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <COMPLETEDORDERS navigate={navigate} params={params} />
    </>
  );
}

export function RTPRIVACYPOLICY(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <PRIVACYPOLICY navigate={navigate} params={params} />
    </>
  );
}

export function RTDAITONN(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <DAITONN navigate={navigate} params={params} />
    </>
  );
}
